import CommonErrorPage from "./Common/CommonErrorPage";

const Error404 = () => {
  return <CommonErrorPage color="danger" page="404" />;
};

export default Error404;
